export default [
    {
        id: 'Pessoa',
        chavePermissao: 'Pessoas',
        title : "Pessoas",
        icon : "fas fa-user",
        order : 0,
        to : "/pessoas",
        role : [],
        expand:false
    },
    {
        id: 'Equipe',
        chavePermissao: 'Equipe',
        title : "Equipe",
        icon : "fas fa-users",
        order : 0,
        to : "/equipe",
        role : [],
        expand:false
    },
    {
        id: 'Usuario',
        chavePermissao: 'Usuarios',
        title : "Usuários",
        icon : "fas fa-user-cog",
        order : 0,
        to : "/usuarios",
        role : [],
        expand:false
    },
    {
        id: 'Empresa',
        chavePermissao: 'Empresas',
        title : "Empresas",
        icon : "fas fa-building",
        order : 0,
        to : "/empresas",
        role : [],
        expand:false
    },
    {
        id: 'ContratoLicenca',
        chavePermissao: 'ContratoLicenca',
        title : "Contratos de Licença",
        icon : "fas fa-file-contract",
        order : 0,
        to : "/contrato_licenca",
        role : [],
        expand:false
    },
    {
        id: 'AprovacaoUsuario',
        chavePermissao: 'AprovacaoUsuario',
        title : "Aprovação de usuários",
        icon : "fas fa-users",
        order : 0,
        to : "/usuarios/aprovacao-usuario/",
        role : [],
        badge : {
            variant : 'danger',
            state : 'sizeUsersToAprove',
            show : {
                expression : '>',
                expected : 0,
            }
        },
        expand:false
    },
    {
        id: 'configuracoes',
        title : "Configurações",
        icon : "fas fa-cog",
        order : 0,
        children : [
            {
                id: 'Perfil',
                chavePermissao: 'Perfis',
                title : "Perfis",
                icon : "",
                order : 0,
                to : "/perfis",
                role : [],
            },
            {
                id: 'TermosServico',
                chavePermissao: 'TermosPolitica',
                title : "Termos e avisos",
                icon : "",
                order : 0,
                to : "/configs/termos/formulario",
                role : [],
            }
        ],
        role : [],
        expand:false
    }
]